var map = {
	"./Normal/001.png": 78535,
	"./Normal/002.png": 11500,
	"./Normal/003.png": 23125,
	"./Normal/004.png": 71066,
	"./Normal/005.png": 60899,
	"./Normal/006.png": 98920,
	"./Normal/007.png": 30961,
	"./Normal/008.png": 92182,
	"./Normal/009.png": 45983,
	"./Normal/010.png": 27161,
	"./Normal/011.png": 20912,
	"./Normal/012.png": 92203,
	"./Normal/013.png": 71074,
	"./Normal/014.png": 58973,
	"./Normal/015.png": 42292,
	"./Normal/016.png": 16783,
	"./Normal/017.png": 77766,
	"./Normal/018.png": 12961,
	"./Normal/019.png": 91832,
	"./Normal/020.png": 55684,
	"./Normal/021.png": 81837,
	"./Normal/022.png": 91158,
	"./Normal/023.png": 69247,
	"./Normal/024.png": 10592,
	"./Normal/025.png": 65417,
	"./Normal/026.png": 274,
	"./Normal/027.png": 49275,
	"./Normal/028.png": 69388,
	"./Normal/029.png": 52277,
	"./Normal/030.png": 14863,
	"./Normal/031.png": 75846,
	"./Normal/032.png": 17085,
	"./Normal/033.png": 95956,
	"./Normal/034.png": 41867,
	"./Normal/035.png": 20738,
	"./Normal/036.png": 68921,
	"./Normal/037.png": 88368,
	"./Normal/038.png": 38903,
	"./Normal/039.png": 95886,
	"./Normal/040.png": 11074,
	"./Normal/041.png": 32203,
	"./Normal/042.png": 78704,
	"./Normal/043.png": 59257,
	"./Normal/044.png": 66182,
	"./Normal/045.png": 5199,
	"./Normal/046.png": 86292,
	"./Normal/047.png": 7421,
	"./Normal/048.png": 73354,
	"./Normal/049.png": 28563,
	"./Normal/050.png": 70253,
	"./Normal/051.png": 30308,
	"./Normal/052.png": 84959,
	"./Normal/053.png": 88630,
	"./Normal/054.png": 4809,
	"./Normal/055.png": 33632,
	"./Normal/056.png": 11963,
	"./Normal/057.png": 14098,
	"./Normal/058.png": 43253,
	"./Normal/059.png": 57804,
	"./Normal/060.png": 25960,
	"./Normal/061.png": 19825,
	"./Normal/062.png": 98714,
	"./Normal/063.png": 62819,
	"./Normal/064.png": 86572,
	"./Normal/065.png": 38837,
	"./Normal/066.png": 36734,
	"./Normal/067.png": 5575,
	"./Normal/068.png": 4480,
	"./Normal/069.png": 82601,
	"./Normal/070.png": 8435,
	"./Normal/071.png": 57674,
	"./Normal/072.png": 6657,
	"./Normal/073.png": 33944,
	"./Normal/074.png": 13559,
	"./Normal/075.png": 23566,
	"./Normal/076.png": 42341,
	"./Normal/077.png": 24828,
	"./Normal/078.png": 5131,
	"./Normal/079.png": 41474,
	"./Normal/080.png": 85270,
	"./Normal/081.png": 98559,
	"./Normal/082.png": 45348,
	"./Normal/083.png": 99245,
	"./Normal/084.png": 94386,
	"./Normal/085.png": 25563,
	"./Normal/086.png": 47232,
	"./Normal/087.png": 25353,
	"./Normal/088.png": 79486,
	"./Normal/089.png": 48327,
	"./Normal/090.png": 21297,
	"./Normal/091.png": 89256,
	"./Normal/092.png": 51235,
	"./Normal/093.png": 61402,
	"./Normal/094.png": 13461,
	"./Normal/095.png": 1836,
	"./Normal/096.png": 68871,
	"./Normal/097.png": 93086,
	"./Normal/098.png": 32489,
	"./Normal/099.png": 8288,
	"./Normal/100.png": 13407,
	"./Normal/101.png": 75958,
	"./Normal/102.png": 91373,
	"./Normal/103.png": 28132,
	"./Normal/104.png": 82939,
	"./Normal/105.png": 61394,
	"./Normal/106.png": 25929,
	"./Normal/107.png": 1728,
	"./Normal/108.png": 45959,
	"./Normal/109.png": 70174,
	"./Normal/110.png": 80564,
	"./Normal/111.png": 1693,
	"./Normal/112.png": 34278,
	"./Normal/113.png": 3023,
	"./Normal/114.png": 7152,
	"./Normal/115.png": 22905,
	"./Normal/116.png": 8898,
	"./Normal/117.png": 72555,
	"./Normal/118.png": 92252,
	"./Normal/119.png": 9765,
	"./Normal/120.png": 50025,
	"./Normal/121.png": 71904,
	"./Normal/122.png": 50235,
	"./Normal/123.png": 19058,
	"./Normal/124.png": 23917,
	"./Normal/125.png": 70020,
	"./Normal/126.png": 23231,
	"./Normal/127.png": 9942,
	"./Normal/128.png": 87249,
	"./Normal/129.png": 93384,
	"./Normal/130.png": 25934,
	"./Normal/131.png": 25431,
	"./Normal/132.png": 1500,
	"./Normal/133.png": 53765,
	"./Normal/134.png": 66986,
	"./Normal/135.png": 98899,
	"./Normal/136.png": 3288,
	"./Normal/137.png": 24417,
	"./Normal/138.png": 12902,
	"./Normal/139.png": 78095,
	"./Normal/140.png": 2979,
	"./Normal/141.png": 1754,
	"./Normal/142.png": 31921,
	"./Normal/143.png": 17704,
	"./Normal/144.png": 9223,
	"./Normal/145.png": 90910,
	"./Normal/146.png": 58261,
	"./Normal/147.png": 72812,
	"./Normal/148.png": 26971,
	"./Normal/149.png": 29106,
	"./Normal/150.png": 52728,
	"./Normal/151.png": 37345,
	"./Normal/152.png": 88362,
	"./Normal/153.png": 43571,
	"./Normal/154.png": 43612,
	"./Normal/155.png": 73029,
	"./Normal/156.png": 1230,
	"./Normal/157.png": 44247,
	"./Normal/158.png": 93712,
	"./Normal/159.png": 74265,
	"./Normal/160.png": 33085,
	"./Normal/161.png": 52,
	"./Normal/162.png": 74543,
	"./Normal/163.png": 35526,
	"./Normal/164.png": 84921,
	"./Normal/165.png": 78672,
	"./Normal/166.png": 49963,
	"./Normal/167.png": 28834,
	"./Normal/168.png": 23365,
	"./Normal/169.png": 40476,
	"./Normal/170.png": 51730,
	"./Normal/171.png": 73275,
	"./Normal/172.png": 92064,
	"./Normal/173.png": 16265,
	"./Normal/174.png": 66294,
	"./Normal/175.png": 3743,
	"./Normal/176.png": 18468,
	"./Normal/177.png": 81709,
	"./Normal/178.png": 28826,
	"./Normal/179.png": 18659,
	"./Normal/180.png": 71319,
	"./Normal/181.png": 97678,
	"./Normal/182.png": 101,
	"./Normal/183.png": 82588,
	"./Normal/184.png": 66195,
	"./Normal/185.png": 15434,
	"./Normal/186.png": 64417,
	"./Normal/187.png": 91704,
	"./Normal/188.png": 93359,
	"./Normal/189.png": 24614,
	"./Normal/190.png": 44332,
	"./Normal/191.png": 96597,
	"./Normal/192.png": 10846,
	"./Normal/193.png": 63335,
	"./Normal/194.png": 83720,
	"./Normal/195.png": 77585,
	"./Normal/196.png": 56474,
	"./Normal/197.png": 20579,
	"./Normal/198.png": 60356,
	"./Normal/199.png": 14253,
	"./Normal/200.png": 20860,
	"./Normal/201.png": 38373,
	"./Normal/201_10.png": 9833,
	"./Normal/201_11.png": 85632,
	"./Normal/201_12.png": 66843,
	"./Normal/201_13.png": 45298,
	"./Normal/201_14.png": 75277,
	"./Normal/201_15.png": 12036,
	"./Normal/201_16.png": 13663,
	"./Normal/201_17.png": 59862,
	"./Normal/201_18.png": 98641,
	"./Normal/201_19.png": 50248,
	"./Normal/201_2.png": 63782,
	"./Normal/201_20.png": 93620,
	"./Normal/201_21.png": 26653,
	"./Normal/201_22.png": 29094,
	"./Normal/201_23.png": 68111,
	"./Normal/201_24.png": 72240,
	"./Normal/201_25.png": 78489,
	"./Normal/201_26.png": 22402,
	"./Normal/201_27.png": 43531,
	"./Normal/201_3.png": 48879,
	"./Normal/201_4.png": 36656,
	"./Normal/201_5.png": 68761,
	"./Normal/201_6.png": 54754,
	"./Normal/201_7.png": 18411,
	"./Normal/201_8.png": 21756,
	"./Normal/201_9.png": 55621,
	"./Normal/202.png": 35950,
	"./Normal/203.png": 9591,
	"./Normal/204.png": 29976,
	"./Normal/205.png": 2689,
	"./Normal/206.png": 53706,
	"./Normal/207.png": 4467,
	"./Normal/208.png": 9172,
	"./Normal/209.png": 30301,
	"./Normal/210.png": 74567,
	"./Normal/211.png": 98782,
	"./Normal/212.png": 19157,
	"./Normal/213.png": 7532,
	"./Normal/214.png": 56931,
	"./Normal/215.png": 67098,
	"./Normal/216.png": 43345,
	"./Normal/217.png": 94952,
	"./Normal/218.png": 58367,
	"./Normal/219.png": 4566,
	"./Normal/220.png": 1014,
	"./Normal/221.png": 80991,
	"./Normal/222.png": 26340,
	"./Normal/223.png": 82637,
	"./Normal/224.png": 10130,
	"./Normal/225.png": 7995,
	"./Normal/226.png": 29664,
	"./Normal/227.png": 841,
	"./Normal/228.png": 71934,
	"./Normal/229.png": 90247,
	"./Normal/230.png": 15857,
	"./Normal/231.png": 21992,
	"./Normal/232.png": 58851,
	"./Normal/233.png": 11098,
	"./Normal/234.png": 34869,
	"./Normal/235.png": 82604,
	"./Normal/236.png": 1607,
	"./Normal/237.png": 49118,
	"./Normal/238.png": 78633,
	"./Normal/239.png": 512,
	"./Normal/240.png": 96960,
	"./Normal/241.png": 51785,
	"./Normal/242.png": 86642,
	"./Normal/243.png": 51995,
	"./Normal/244.png": 42052,
	"./Normal/245.png": 68205,
	"./Normal/246.png": 77526,
	"./Normal/247.png": 55615,
	"./Normal/248.png": 49064,
	"./Normal/249.png": 89009,
	"./Normal/250.png": 28235,
	"./Normal/251.png": 7106,
	"./Normal/252.png": 71641,
	"./Normal/253.png": 74736,
	"./Normal/254.png": 1231,
	"./Normal/255.png": 78566,
	"./Normal/256.png": 3453,
	"./Normal/257.png": 82324,
	"./Normal/258.png": 24595,
	"./Normal/259.png": 69386,
	"./Normal/260.png": 57434,
	"./Normal/261.png": 47267,
	"./Normal/262.png": 85288,
	"./Normal/263.png": 33681,
	"./Normal/264.png": 89118,
	"./Normal/265.png": 64903,
	"./Normal/266.png": 97868,
	"./Normal/267.png": 9493,
	"./Normal/268.png": 80338,
	"./Normal/269.png": 1883,
	"./Normal/270.png": 51973,
	"./Normal/271.png": 69084,
	"./Normal/272.png": 27191,
	"./Normal/273.png": 81614,
	"./Normal/274.png": 99329,
	"./Normal/275.png": 78200,
	"./Normal/276.png": 23955,
	"./Normal/277.png": 85098,
	"./Normal/278.png": 61693,
	"./Normal/279.png": 28660,
	"./Normal/280.png": 66404,
	"./Normal/281.png": 29645,
	"./Normal/282.png": 14230,
	"./Normal/283.png": 68031,
	"./Normal/284.png": 40000,
	"./Normal/285.png": 64201,
	"./Normal/286.png": 99666,
	"./Normal/287.png": 21211,
	"./Normal/288.png": 17196,
	"./Normal/289.png": 28821,
	"./Normal/290.png": 22479,
	"./Normal/291.png": 83462,
	"./Normal/292.png": 81021,
	"./Normal/293.png": 47988,
	"./Normal/294.png": 97899,
	"./Normal/295.png": 76770,
	"./Normal/296.png": 32857,
	"./Normal/297.png": 26608,
	"./Normal/298.png": 46519,
	"./Normal/299.png": 942,
	"./Normal/300.png": 19261,
	"./Normal/301.png": 98132,
	"./Normal/302.png": 20591,
	"./Normal/303.png": 51846,
	"./Normal/304.png": 40473,
	"./Normal/305.png": 24720,
	"./Normal/306.png": 90123,
	"./Normal/307.png": 26466,
	"./Normal/308.png": 27333,
	"./Normal/309.png": 9820,
	"./Normal/310.png": 36626,
	"./Normal/311.png": 51451,
	"./Normal/312.png": 89472,
	"./Normal/313.png": 67593,
	"./Normal/314.png": 27510,
	"./Normal/315.png": 40799,
	"./Normal/316.png": 87588,
	"./Normal/317.png": 41485,
	"./Normal/318.png": 83706,
	"./Normal/319.png": 47811,
	"./Normal/320.png": 32131,
	"./Normal/321.png": 10554,
	"./Normal/322.png": 35217,
	"./Normal/323.png": 95272,
	"./Normal/324.png": 70439,
	"./Normal/325.png": 99102,
	"./Normal/326.png": 84853,
	"./Normal/327.png": 1964,
	"./Normal/328.png": 81851,
	"./Normal/329.png": 32850,
	"./Normal/330.png": 24408,
	"./Normal/331.png": 45537,
	"./Normal/332.png": 14954,
	"./Normal/333.png": 70163,
	"./Normal/334.png": 15292,
	"./Normal/335.png": 81829,
	"./Normal/336.png": 27822,
	"./Normal/337.png": 57047,
	"./Normal/338.png": 53488,
	"./Normal/339.png": 59737,
	"./Normal/340.png": 30697,
	"./Normal/341.png": 75872,
	"./Normal/342.png": 54203,
	"./Normal/343.png": 39986,
	"./Normal/344.png": 12493,
	"./Normal/345.png": 72548,
	"./Normal/346.png": 27199,
	"./Normal/347.png": 30870,
	"./Normal/348.png": 42801,
	"./Normal/349.png": 44936,
	"./Normal/350.png": 12110,
	"./Normal/351.png": 71479,
	"./Normal/352.png": 70844,
	"./Normal/353.png": 261,
	"./Normal/354.png": 15594,
	"./Normal/355.png": 54451,
	"./Normal/356.png": 79960,
	"./Normal/357.png": 64577,
	"./Normal/358.png": 8422,
	"./Normal/359.png": 47439,
	"./Normal/360.png": 50463,
	"./Normal/361.png": 37174,
	"./Normal/362.png": 51149,
	"./Normal/363.png": 97252,
	"./Normal/364.png": 61115,
	"./Normal/365.png": 46290,
	"./Normal/366.png": 77257,
	"./Normal/367.png": 99136,
	"./Normal/368.png": 83879,
	"./Normal/369.png": 31390,
	"./Normal/370.png": 212,
	"./Normal/371.png": 21341,
	"./Normal/372.png": 23782,
	"./Normal/373.png": 5327,
	"./Normal/374.png": 36304,
	"./Normal/375.png": 26201,
	"./Normal/376.png": 59618,
	"./Normal/377.png": 50123,
	"./Normal/378.png": 28732,
	"./Normal/379.png": 64645,
	"./Normal/380.png": 14165,
	"./Normal/381.png": 61900,
	"./Normal/382.png": 80903,
	"./Normal/383.png": 12062,
	"./Normal/384.png": 95153,
	"./Normal/385.png": 1288,
	"./Normal/386.png": 38147,
	"./Normal/386_0.png": 4006,
	"./Normal/386_1.png": 43023,
	"./Normal/386_2.png": 7764,
	"./Normal/386_3.png": 45245,
	"./Normal/387.png": 74042,
	"./Normal/388.png": 31821,
	"./Normal/389.png": 77924,
	"./Normal/390.png": 74890,
	"./Normal/391.png": 6803,
	"./Normal/392.png": 11192,
	"./Normal/393.png": 32321,
	"./Normal/394.png": 33838,
	"./Normal/395.png": 33335,
	"./Normal/396.png": 9404,
	"./Normal/397.png": 45317,
	"./Normal/398.png": 40290,
	"./Normal/399.png": 30795,
	"./Normal/400.png": 12314,
	"./Normal/401.png": 76419,
	"./Normal/402.png": 39560,
	"./Normal/403.png": 33425,
	"./Normal/404.png": 50334,
	"./Normal/405.png": 19175,
	"./Normal/406.png": 172,
	"./Normal/407.png": 52437,
	"./Normal/408.png": 65234,
	"./Normal/409.png": 96411,
	"./Normal/410.png": 55941,
	"./Normal/411.png": 38428,
	"./Normal/412.png": 27159,
	"./Normal/412_2.png": 24640,
	"./Normal/413.png": 53518,
	"./Normal/413_2.png": 83553,
	"./Normal/414.png": 20257,
	"./Normal/415.png": 47544,
	"./Normal/416.png": 22035,
	"./Normal/417.png": 71274,
	"./Normal/418.png": 47869,
	"./Normal/419.png": 26740,
	"./Normal/420.png": 47904,
	"./Normal/421.png": 72105,
	"./Normal/422.png": 7570,
	"./Normal/423.png": 29115,
	"./Normal/424.png": 74308,
	"./Normal/425.png": 37549,
	"./Normal/426.png": 5782,
	"./Normal/427.png": 59583,
	"./Normal/428.png": 12520,
	"./Normal/429.png": 60913,
	"./Normal/430.png": 5803,
	"./Normal/431.png": 84674,
	"./Normal/432.png": 40761,
	"./Normal/433.png": 34512,
	"./Normal/434.png": 30383,
	"./Normal/435.png": 91366,
	"./Normal/436.png": 88925,
	"./Normal/437.png": 55892,
	"./Normal/438.png": 51187,
	"./Normal/439.png": 95978,
	"./Normal/440.png": 4758,
	"./Normal/441.png": 82847,
	"./Normal/442.png": 69284,
	"./Normal/443.png": 95437,
	"./Normal/444.png": 13874,
	"./Normal/445.png": 79227,
	"./Normal/446.png": 24192,
	"./Normal/447.png": 79017,
	"./Normal/448.png": 80126,
	"./Normal/449.png": 51463,
	"./Normal/450.png": 87761,
	"./Normal/451.png": 73544,
	"./Normal/452.png": 58819,
	"./Normal/453.png": 57594,
	"./Normal/454.png": 14101,
	"./Normal/455.png": 28652,
	"./Normal/456.png": 65063,
	"./Normal/457.png": 46750,
	"./Normal/458.png": 75657,
	"./Normal/459.png": 82099,
	"./Normal/460.png": 57340,
	"./Normal/461.png": 9605,
	"./Normal/462.png": 81774,
	"./Normal/463.png": 81271,
	"./Normal/464.png": 59128,
	"./Normal/465.png": 80257,
	"./Normal/466.png": 22826,
	"./Normal/467.png": 54739,
	"./Normal/468.png": 28820,
	"./Normal/469.png": 49949,
	"./Normal/470.png": 28839,
	"./Normal/471.png": 59998,
	"./Normal/472.png": 62101,
	"./Normal/473.png": 9836,
	"./Normal/474.png": 86083,
	"./Normal/475.png": 21978,
	"./Normal/476.png": 43089,
	"./Normal/477.png": 49224,
	"./Normal/478.png": 79071,
	"./Normal/479.png": 65782,
	"./Normal/479_2.png": 67385,
	"./Normal/479_3.png": 70480,
	"./Normal/479_4.png": 13327,
	"./Normal/479_5.png": 74310,
	"./Normal/480.png": 64738,
	"./Normal/481.png": 28395,
	"./Normal/482.png": 62992,
	"./Normal/483.png": 78745,
	"./Normal/484.png": 90118,
	"./Normal/485.png": 58863,
	"./Normal/486.png": 36404,
	"./Normal/487.png": 57533,
	"./Normal/488.png": 80938,
	"./Normal/489.png": 31699,
	"./Normal/490.png": 47213,
	"./Normal/491.png": 83972,
	"./Normal/492.png": 91628,
	"./Normal/493.png": 15446,
	"./Normal/493_10.png": 32472,
	"./Normal/493_11.png": 21537,
	"./Normal/493_12.png": 56202,
	"./Normal/493_13.png": 23315,
	"./Normal/493_14.png": 23356,
	"./Normal/493_15.png": 40869,
	"./Normal/493_16.png": 38446,
	"./Normal/493_17.png": 12087,
	"./Normal/493_2.png": 84665,
	"./Normal/493_3.png": 78416,
	"./Normal/493_4.png": 74287,
	"./Normal/493_5.png": 35270,
	"./Normal/493_6.png": 32829,
	"./Normal/493_7.png": 99796,
	"./Normal/493_8.png": 95091,
	"./Normal/493_9.png": 39882,
	"./Normal/494.png": 81769,
	"./Shiny/001s.png": 65374,
	"./Shiny/002s.png": 71179,
	"./Shiny/003s.png": 73216,
	"./Shiny/004s.png": 53309,
	"./Shiny/005s.png": 45450,
	"./Shiny/006s.png": 35111,
	"./Shiny/007s.png": 97116,
	"./Shiny/008s.png": 30793,
	"./Shiny/009s.png": 66406,
	"./Shiny/010s.png": 69776,
	"./Shiny/011s.png": 86459,
	"./Shiny/012s.png": 62158,
	"./Shiny/013s.png": 68145,
	"./Shiny/014s.png": 18700,
	"./Shiny/015s.png": 90135,
	"./Shiny/016s.png": 71962,
	"./Shiny/017s.png": 70349,
	"./Shiny/018s.png": 95480,
	"./Shiny/019s.png": 64547,
	"./Shiny/020s.png": 63715,
	"./Shiny/021s.png": 64024,
	"./Shiny/022s.png": 72057,
	"./Shiny/023s.png": 52406,
	"./Shiny/024s.png": 16895,
	"./Shiny/025s.png": 13204,
	"./Shiny/026s.png": 66997,
	"./Shiny/027s.png": 12386,
	"./Shiny/028s.png": 859,
	"./Shiny/029s.png": 97200,
	"./Shiny/030s.png": 62450,
	"./Shiny/031s.png": 22725,
	"./Shiny/032s.png": 19716,
	"./Shiny/033s.png": 27791,
	"./Shiny/034s.png": 710,
	"./Shiny/035s.png": 90057,
	"./Shiny/036s.png": 44136,
	"./Shiny/037s.png": 19027,
	"./Shiny/038s.png": 28394,
	"./Shiny/039s.png": 99517,
	"./Shiny/040s.png": 14629,
	"./Shiny/041s.png": 65650,
	"./Shiny/042s.png": 37487,
	"./Shiny/043s.png": 62596,
	"./Shiny/044s.png": 11081,
	"./Shiny/045s.png": 4166,
	"./Shiny/046s.png": 73811,
	"./Shiny/047s.png": 47944,
	"./Shiny/048s.png": 42397,
	"./Shiny/049s.png": 38090,
	"./Shiny/050s.png": 75092,
	"./Shiny/051s.png": 78783,
	"./Shiny/052s.png": 74274,
	"./Shiny/053s.png": 28885,
	"./Shiny/054s.png": 25912,
	"./Shiny/055s.png": 25603,
	"./Shiny/056s.png": 14294,
	"./Shiny/057s.png": 33945,
	"./Shiny/058s.png": 34636,
	"./Shiny/059s.png": 36695,
	"./Shiny/060s.png": 45127,
	"./Shiny/061s.png": 49308,
	"./Shiny/062s.png": 2941,
	"./Shiny/063s.png": 40618,
	"./Shiny/064s.png": 72395,
	"./Shiny/065s.png": 73824,
	"./Shiny/066s.png": 69889,
	"./Shiny/067s.png": 23454,
	"./Shiny/068s.png": 93039,
	"./Shiny/069s.png": 31940,
	"./Shiny/070s.png": 42550,
	"./Shiny/071s.png": 5849,
	"./Shiny/072s.png": 2584,
	"./Shiny/073s.png": 97507,
	"./Shiny/074s.png": 82242,
	"./Shiny/075s.png": 91765,
	"./Shiny/076s.png": 73172,
	"./Shiny/077s.png": 56735,
	"./Shiny/078s.png": 64270,
	"./Shiny/079s.png": 17777,
	"./Shiny/080s.png": 28169,
	"./Shiny/081s.png": 38822,
	"./Shiny/082s.png": 57139,
	"./Shiny/083s.png": 82248,
	"./Shiny/084s.png": 60837,
	"./Shiny/085s.png": 562,
	"./Shiny/086s.png": 65903,
	"./Shiny/087s.png": 57828,
	"./Shiny/088s.png": 92897,
	"./Shiny/089s.png": 72638,
	"./Shiny/090s.png": 37272,
	"./Shiny/091s.png": 23395,
	"./Shiny/092s.png": 49206,
	"./Shiny/093s.png": 19833,
	"./Shiny/094s.png": 56532,
	"./Shiny/095s.png": 56223,
	"./Shiny/096s.png": 58050,
	"./Shiny/097s.png": 26453,
	"./Shiny/098s.png": 44976,
	"./Shiny/099s.png": 62875,
	"./Shiny/100s.png": 76006,
	"./Shiny/101s.png": 40393,
	"./Shiny/102s.png": 15432,
	"./Shiny/103s.png": 24947,
	"./Shiny/104s.png": 16786,
	"./Shiny/105s.png": 35141,
	"./Shiny/106s.png": 52260,
	"./Shiny/107s.png": 43503,
	"./Shiny/108s.png": 74974,
	"./Shiny/109s.png": 78881,
	"./Shiny/110s.png": 55287,
	"./Shiny/111s.png": 83852,
	"./Shiny/112s.png": 96973,
	"./Shiny/113s.png": 85530,
	"./Shiny/114s.png": 27,
	"./Shiny/115s.png": 65776,
	"./Shiny/116s.png": 7441,
	"./Shiny/117s.png": 57934,
	"./Shiny/118s.png": 93375,
	"./Shiny/119s.png": 93684,
	"./Shiny/120s.png": 41540,
	"./Shiny/121s.png": 2639,
	"./Shiny/122s.png": 79826,
	"./Shiny/123s.png": 28197,
	"./Shiny/124s.png": 69064,
	"./Shiny/125s.png": 90931,
	"./Shiny/126s.png": 25638,
	"./Shiny/127s.png": 41609,
	"./Shiny/128s.png": 58908,
	"./Shiny/129s.png": 54727,
	"./Shiny/130s.png": 49173,
	"./Shiny/131s.png": 91234,
	"./Shiny/132s.png": 65119,
	"./Shiny/133s.png": 21780,
	"./Shiny/134s.png": 54457,
	"./Shiny/135s.png": 65430,
	"./Shiny/136s.png": 57795,
	"./Shiny/137s.png": 88728,
	"./Shiny/138s.png": 79949,
	"./Shiny/139s.png": 81562,
	"./Shiny/140s.png": 29954,
	"./Shiny/141s.png": 39477,
	"./Shiny/142s.png": 4532,
	"./Shiny/143s.png": 4447,
	"./Shiny/144s.png": 90262,
	"./Shiny/145s.png": 37209,
	"./Shiny/146s.png": 50296,
	"./Shiny/147s.png": 28867,
	"./Shiny/148s.png": 73306,
	"./Shiny/149s.png": 53901,
	"./Shiny/150s.png": 29043,
	"./Shiny/151s.png": 7176,
	"./Shiny/152s.png": 79721,
	"./Shiny/153s.png": 63750,
	"./Shiny/154s.png": 40751,
	"./Shiny/155s.png": 79652,
	"./Shiny/156s.png": 66309,
	"./Shiny/157s.png": 17938,
	"./Shiny/158s.png": 20107,
	"./Shiny/159s.png": 21536,
	"./Shiny/160s.png": 33760,
	"./Shiny/161s.png": 4587,
	"./Shiny/162s.png": 9790,
	"./Shiny/163s.png": 13697,
	"./Shiny/164s.png": 16796,
	"./Shiny/165s.png": 8167,
	"./Shiny/166s.png": 87306,
	"./Shiny/167s.png": 74781,
	"./Shiny/168s.png": 19400,
	"./Shiny/169s.png": 94291,
	"./Shiny/170s.png": 57809,
	"./Shiny/171s.png": 5742,
	"./Shiny/172s.png": 76123,
	"./Shiny/173s.png": 56112,
	"./Shiny/174s.png": 64013,
	"./Shiny/175s.png": 92474,
	"./Shiny/176s.png": 33719,
	"./Shiny/177s.png": 48012,
	"./Shiny/178s.png": 47321,
	"./Shiny/179s.png": 11318,
	"./Shiny/180s.png": 96046,
	"./Shiny/181s.png": 45553,
	"./Shiny/182s.png": 3888,
	"./Shiny/183s.png": 38139,
	"./Shiny/184s.png": 23642,
	"./Shiny/185s.png": 35085,
	"./Shiny/186s.png": 21964,
	"./Shiny/187s.png": 93399,
	"./Shiny/188s.png": 24470,
	"./Shiny/189s.png": 95097,
	"./Shiny/190s.png": 64607,
	"./Shiny/191s.png": 44564,
	"./Shiny/192s.png": 14709,
	"./Shiny/193s.png": 60098,
	"./Shiny/194s.png": 11427,
	"./Shiny/195s.png": 11736,
	"./Shiny/196s.png": 19769,
	"./Shiny/197s.png": 83766,
	"./Shiny/198s.png": 22519,
	"./Shiny/199s.png": 20460,
	"./Shiny/200s.png": 49627,
	"./Shiny/201s.png": 55024,
	"./Shiny/201s_10.png": 5562,
	"./Shiny/201s_11.png": 23139,
	"./Shiny/201s_12.png": 21512,
	"./Shiny/201s_13.png": 35729,
	"./Shiny/201s_14.png": 94718,
	"./Shiny/201s_15.png": 13031,
	"./Shiny/201s_16.png": 92972,
	"./Shiny/201s_17.png": 62069,
	"./Shiny/201s_18.png": 32914,
	"./Shiny/201s_19.png": 30779,
	"./Shiny/201s_2.png": 74019,
	"./Shiny/201s_20.png": 76363,
	"./Shiny/201s_21.png": 12706,
	"./Shiny/201s_22.png": 26713,
	"./Shiny/201s_23.png": 10960,
	"./Shiny/201s_24.png": 23183,
	"./Shiny/201s_25.png": 38086,
	"./Shiny/201s_26.png": 21853,
	"./Shiny/201s_27.png": 84372,
	"./Shiny/201s_3.png": 26266,
	"./Shiny/201s_4.png": 50037,
	"./Shiny/201s_5.png": 97772,
	"./Shiny/201s_6.png": 16775,
	"./Shiny/201s_7.png": 64286,
	"./Shiny/201s_8.png": 93801,
	"./Shiny/201s_9.png": 15680,
	"./Shiny/202s.png": 27537,
	"./Shiny/203s.png": 74030,
	"./Shiny/204s.png": 59031,
	"./Shiny/205s.png": 3948,
	"./Shiny/206s.png": 15949,
	"./Shiny/207s.png": 35354,
	"./Shiny/208s.png": 90915,
	"./Shiny/209s.png": 12344,
	"./Shiny/210s.png": 47850,
	"./Shiny/211s.png": 52157,
	"./Shiny/212s.png": 60988,
	"./Shiny/213s.png": 3335,
	"./Shiny/214s.png": 82270,
	"./Shiny/215s.png": 45057,
	"./Shiny/216s.png": 79616,
	"./Shiny/217s.png": 30603,
	"./Shiny/218s.png": 59058,
	"./Shiny/219s.png": 24389,
	"./Shiny/220s.png": 43705,
	"./Shiny/221s.png": 7702,
	"./Shiny/222s.png": 35363,
	"./Shiny/223s.png": 35672,
	"./Shiny/224s.png": 22293,
	"./Shiny/225s.png": 84034,
	"./Shiny/226s.png": 88543,
	"./Shiny/227s.png": 68500,
	"./Shiny/228s.png": 54193,
	"./Shiny/229s.png": 18478,
	"./Shiny/230s.png": 15784,
	"./Shiny/231s.png": 90675,
	"./Shiny/232s.png": 72358,
	"./Shiny/233s.png": 61705,
	"./Shiny/234s.png": 91364,
	"./Shiny/235s.png": 99439,
	"./Shiny/236s.png": 34098,
	"./Shiny/237s.png": 78021,
	"./Shiny/238s.png": 30144,
	"./Shiny/239s.png": 971,
	"./Shiny/240s.png": 89759,
	"./Shiny/241s.png": 90068,
	"./Shiny/242s.png": 59989,
	"./Shiny/243s.png": 91586,
	"./Shiny/244s.png": 40579,
	"./Shiny/245s.png": 54456,
	"./Shiny/246s.png": 53369,
	"./Shiny/247s.png": 82742,
	"./Shiny/248s.png": 51671,
	"./Shiny/249s.png": 80236,
	"./Shiny/250s.png": 33806,
	"./Shiny/251s.png": 23441,
	"./Shiny/252s.png": 41424,
	"./Shiny/253s.png": 41755,
	"./Shiny/254s.png": 43610,
	"./Shiny/255s.png": 41997,
	"./Shiny/256s.png": 90348,
	"./Shiny/257s.png": 61783,
	"./Shiny/258s.png": 27478,
	"./Shiny/259s.png": 16505,
	"./Shiny/260s.png": 74589,
	"./Shiny/261s.png": 95914,
	"./Shiny/262s.png": 39156,
	"./Shiny/263s.png": 20956,
	"./Shiny/264s.png": 41537,
	"./Shiny/265s.png": 95102,
	"./Shiny/266s.png": 44043,
	"./Shiny/267s.png": 45472,
	"./Shiny/268s.png": 90245,
	"./Shiny/269s.png": 41874,
	"./Shiny/270s.png": 65836,
	"./Shiny/271s.png": 20919,
	"./Shiny/272s.png": 97242,
	"./Shiny/273s.png": 77837,
	"./Shiny/274s.png": 16912,
	"./Shiny/275s.png": 11515,
	"./Shiny/276s.png": 35918,
	"./Shiny/277s.png": 89425,
	"./Shiny/278s.png": 28468,
	"./Shiny/279s.png": 28383,
	"./Shiny/280s.png": 45459,
	"./Shiny/281s.png": 19592,
	"./Shiny/282s.png": 82729,
	"./Shiny/283s.png": 75814,
	"./Shiny/284s.png": 9135,
	"./Shiny/285s.png": 34244,
	"./Shiny/286s.png": 86277,
	"./Shiny/287s.png": 20946,
	"./Shiny/288s.png": 76139,
	"./Shiny/289s.png": 25152,
	"./Shiny/290s.png": 29570,
	"./Shiny/291s.png": 84181,
	"./Shiny/292s.png": 30388,
	"./Shiny/293s.png": 50431,
	"./Shiny/294s.png": 69590,
	"./Shiny/295s.png": 5593,
	"./Shiny/296s.png": 97560,
	"./Shiny/297s.png": 97251,
	"./Shiny/298s.png": 50746,
	"./Shiny/299s.png": 22285,
	"./Shiny/300s.png": 93432,
	"./Shiny/301s.png": 88355,
	"./Shiny/302s.png": 33398,
	"./Shiny/303s.png": 96697,
	"./Shiny/304s.png": 64020,
	"./Shiny/305s.png": 63935,
	"./Shiny/306s.png": 73090,
	"./Shiny/307s.png": 98965,
	"./Shiny/308s.png": 36112,
	"./Shiny/309s.png": 47067,
	"./Shiny/310s.png": 39209,
	"./Shiny/311s.png": 6886,
	"./Shiny/312s.png": 72179,
	"./Shiny/313s.png": 66664,
	"./Shiny/314s.png": 25797,
	"./Shiny/315s.png": 77426,
	"./Shiny/316s.png": 239,
	"./Shiny/317s.png": 22788,
	"./Shiny/318s.png": 77089,
	"./Shiny/319s.png": 14302,
	"./Shiny/320s.png": 62810,
	"./Shiny/321s.png": 61197,
	"./Shiny/322s.png": 25900,
	"./Shiny/323s.png": 80983,
	"./Shiny/324s.png": 53006,
	"./Shiny/325s.png": 58993,
	"./Shiny/326s.png": 76976,
	"./Shiny/327s.png": 77307,
	"./Shiny/328s.png": 72482,
	"./Shiny/329s.png": 46773,
	"./Shiny/330s.png": 62027,
	"./Shiny/331s.png": 64064,
	"./Shiny/332s.png": 76481,
	"./Shiny/333s.png": 56222,
	"./Shiny/334s.png": 42311,
	"./Shiny/335s.png": 4316,
	"./Shiny/336s.png": 44157,
	"./Shiny/337s.png": 52650,
	"./Shiny/338s.png": 22547,
	"./Shiny/339s.png": 96680,
	"./Shiny/340s.png": 66204,
	"./Shiny/341s.png": 4199,
	"./Shiny/342s.png": 98186,
	"./Shiny/343s.png": 6045,
	"./Shiny/344s.png": 25952,
	"./Shiny/345s.png": 23915,
	"./Shiny/346s.png": 18110,
	"./Shiny/347s.png": 38369,
	"./Shiny/348s.png": 11748,
	"./Shiny/349s.png": 86639,
	"./Shiny/350s.png": 40109,
	"./Shiny/351s.png": 45018,
	"./Shiny/352s.png": 98423,
	"./Shiny/353s.png": 43340,
	"./Shiny/354s.png": 66929,
	"./Shiny/355s.png": 17422,
	"./Shiny/356s.png": 43163,
	"./Shiny/357s.png": 25264,
	"./Shiny/358s.png": 6741,
	"./Shiny/359s.png": 54690,
	"./Shiny/360s.png": 52926,
	"./Shiny/361s.png": 73185,
	"./Shiny/362s.png": 76896,
	"./Shiny/363s.png": 64075,
	"./Shiny/364s.png": 46794,
	"./Shiny/365s.png": 17917,
	"./Shiny/366s.png": 59932,
	"./Shiny/367s.png": 51303,
	"./Shiny/368s.png": 19110,
	"./Shiny/369s.png": 8457,
	"./Shiny/370s.png": 28335,
	"./Shiny/371s.png": 53444,
	"./Shiny/372s.png": 5477,
	"./Shiny/373s.png": 56498,
	"./Shiny/374s.png": 64659,
	"./Shiny/375s.png": 55144,
	"./Shiny/376s.png": 18281,
	"./Shiny/377s.png": 11366,
	"./Shiny/378s.png": 84423,
	"./Shiny/379s.png": 42076,
	"./Shiny/380s.png": 77488,
	"./Shiny/381s.png": 81147,
	"./Shiny/382s.png": 27118,
	"./Shiny/383s.png": 62833,
	"./Shiny/384s.png": 53036,
	"./Shiny/385s.png": 55095,
	"./Shiny/386s.png": 97498,
	"./Shiny/386s_2.png": 65557,
	"./Shiny/386s_3.png": 29644,
	"./Shiny/387s.png": 69037,
	"./Shiny/388s.png": 44312,
	"./Shiny/389s.png": 44003,
	"./Shiny/390s.png": 53697,
	"./Shiny/391s.png": 7262,
	"./Shiny/392s.png": 39243,
	"./Shiny/393s.png": 88256,
	"./Shiny/394s.png": 60797,
	"./Shiny/395s.png": 56490,
	"./Shiny/396s.png": 11975,
	"./Shiny/397s.png": 69628,
	"./Shiny/398s.png": 45833,
	"./Shiny/399s.png": 38918,
	"./Shiny/400s.png": 8509,
	"./Shiny/401s.png": 4202,
	"./Shiny/402s.png": 59687,
	"./Shiny/403s.png": 17340,
	"./Shiny/404s.png": 1409,
	"./Shiny/405s.png": 38622,
	"./Shiny/406s.png": 86955,
	"./Shiny/407s.png": 35968,
	"./Shiny/408s.png": 80741,
	"./Shiny/409s.png": 31762,
	"./Shiny/410s.png": 748,
	"./Shiny/411s.png": 2807,
	"./Shiny/412s.png": 45210,
	"./Shiny/412s_2.png": 70293,
	"./Shiny/413s.png": 16749,
	"./Shiny/413s_2.png": 98750,
	"./Shiny/414s.png": 8848,
	"./Shiny/415s.png": 28859,
	"./Shiny/416s.png": 74830,
	"./Shiny/417s.png": 10545,
	"./Shiny/418s.png": 24852,
	"./Shiny/419s.png": 44895,
	"./Shiny/420s.png": 55967,
	"./Shiny/421s.png": 28980,
	"./Shiny/422s.png": 56373,
	"./Shiny/423s.png": 82082,
	"./Shiny/424s.png": 64995,
	"./Shiny/425s.png": 95928,
	"./Shiny/426s.png": 61657,
	"./Shiny/427s.png": 56278,
	"./Shiny/428s.png": 90583,
	"./Shiny/429s.png": 19148,
	"./Shiny/430s.png": 30382,
	"./Shiny/431s.png": 83889,
	"./Shiny/432s.png": 11376,
	"./Shiny/433s.png": 22331,
	"./Shiny/434s.png": 91706,
	"./Shiny/435s.png": 88653,
	"./Shiny/436s.png": 60300,
	"./Shiny/437s.png": 15383,
	"./Shiny/438s.png": 8662,
	"./Shiny/439s.png": 71961,
	"./Shiny/440s.png": 47833,
	"./Shiny/441s.png": 77206,
	"./Shiny/442s.png": 51395,
	"./Shiny/443s.png": 48920,
	"./Shiny/444s.png": 54453,
	"./Shiny/445s.png": 86050,
	"./Shiny/446s.png": 84223,
	"./Shiny/447s.png": 84532,
	"./Shiny/448s.png": 14641,
	"./Shiny/449s.png": 48782,
	"./Shiny/450s.png": 6280,
	"./Shiny/451s.png": 15795,
	"./Shiny/452s.png": 66854,
	"./Shiny/453s.png": 31241,
	"./Shiny/454s.png": 59460,
	"./Shiny/455s.png": 34351,
	"./Shiny/456s.png": 7634,
	"./Shiny/457s.png": 25989,
	"./Shiny/458s.png": 73664,
	"./Shiny/459s.png": 71627,
	"./Shiny/460s.png": 66971,
	"./Shiny/461s.png": 63312,
	"./Shiny/462s.png": 48657,
	"./Shiny/463s.png": 12942,
	"./Shiny/464s.png": 40919,
	"./Shiny/465s.png": 38860,
	"./Shiny/466s.png": 54861,
	"./Shiny/467s.png": 83322,
	"./Shiny/468s.png": 29827,
	"./Shiny/469s.png": 30136,
	"./Shiny/470s.png": 94506,
	"./Shiny/471s.png": 65629,
	"./Shiny/472s.png": 7644,
	"./Shiny/473s.png": 99015,
	"./Shiny/474s.png": 638,
	"./Shiny/475s.png": 20897,
	"./Shiny/476s.png": 24608,
	"./Shiny/477s.png": 95435,
	"./Shiny/478s.png": 28562,
	"./Shiny/479s.png": 72485,
	"./Shiny/479s_2.png": 82214,
	"./Shiny/479s_3.png": 21231,
	"./Shiny/479s_4.png": 78384,
	"./Shiny/479s_5.png": 75289,
	"./Shiny/480s.png": 56885,
	"./Shiny/481s.png": 2274,
	"./Shiny/482s.png": 6783,
	"./Shiny/483s.png": 86740,
	"./Shiny/484s.png": 61945,
	"./Shiny/485s.png": 25942,
	"./Shiny/486s.png": 53603,
	"./Shiny/487s.png": 53912,
	"./Shiny/488s.png": 78637,
	"./Shiny/489s.png": 7098,
	"./Shiny/490s.png": 9604,
	"./Shiny/491s.png": 17679,
	"./Shiny/492s.png": 52338,
	"./Shiny/493s_10.png": 97161,
	"./Shiny/493s_11.png": 42336,
	"./Shiny/493s_12.png": 4315,
	"./Shiny/493s_13.png": 6450,
	"./Shiny/493s_14.png": 78957,
	"./Shiny/493s_15.png": 39012,
	"./Shiny/493s_16.png": 93663,
	"./Shiny/493s_17.png": 97334,
	"./Shiny/493s_2.png": 52870,
	"./Shiny/493s_3.png": 91887,
	"./Shiny/493s_4.png": 49040,
	"./Shiny/493s_5.png": 45945,
	"./Shiny/493s_6.png": 97762,
	"./Shiny/493s_7.png": 18891,
	"./Shiny/493s_8.png": 92911,
	"./Shiny/493s_9.png": 44709,
	"./Shiny/494s.png": 34024,
	"./characters/Red.png": 76222,
	"./games/04NewBarkTown.mp3": 69844,
	"./games/08ObtainedAKeyItem.mp3": 79167,
	"./games/12LevelUp.mp3": 61122,
	"./games/21PokédexEvaluationNoGood.mp3": 82579,
	"./games/33AzaleaTown.mp3": 59502,
	"./games/43BattleGymLeaderJohtoVersion.mp3": 36381,
	"./games/Playground2.png": 46295,
	"./games/Snake.png": 30140,
	"./reddit/Josephemer_.png": 17330,
	"./reddit/KoolLeo11.png": 90248,
	"./textures/DarkGrass/sprite-607-4.png": 90284,
	"./textures/DarkGrass/sprite-607-5.png": 1909,
	"./textures/DarkGrass/sprite-607-6.png": 81534,
	"./textures/DarkGrass/sprite-608-4.png": 40883,
	"./textures/DarkGrass/sprite-608-5.png": 90122,
	"./textures/DarkGrass/sprite-608-6.png": 39105,
	"./textures/DarkGrass/sprite-609-4.png": 52574,
	"./textures/DarkGrass/sprite-609-5.png": 5063,
	"./textures/DarkGrass/sprite-609-6.png": 2412,
	"./textures/LightGrass/sprite-597-1.png": 85953,
	"./textures/LightGrass/sprite-597-2.png": 55370,
	"./textures/LightGrass/sprite-597-3.png": 10579,
	"./textures/LightGrass/sprite-598-1.png": 20414,
	"./textures/LightGrass/sprite-598-2.png": 87765,
	"./textures/LightGrass/sprite-598-3.png": 18668,
	"./textures/LightGrass/sprite-599-1.png": 96947,
	"./textures/LightGrass/sprite-599-2.png": 22456,
	"./textures/LightGrass/sprite-599-3.png": 95169,
	"./textures/grass.png": 25261,
	"./textures/grass2.png": 63083,
	"./textures/grass3.png": 88930,
	"./textures/grassBottom.png": 77608,
	"./textures/grassBottomLeft.png": 11687,
	"./textures/grassBottomRight.png": 57656,
	"./textures/grassLeft.png": 10598,
	"./textures/grassRight.png": 2651,
	"./textures/grassTop.png": 39532,
	"./textures/grassTopLeft.png": 16747,
	"./textures/grassTopRight.png": 57044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76324;